<div class="container animated-fade-in">
  <div class="row mb-2">
    <div class="col-12">
      <div class="card card-hover-effect">
        <div class="card-header compact-header">
          <h2><i class="fa fa-money"></i> Dealer Yearly Revenue</h2>
        </div>
        <div class="card-body compact-body">
          <!-- Filter Section -->
          <div class="filter-container">
            <button class="btn btn-sm btn-outline-primary filter-toggle mb-2" type="button" (click)="toggleFilters()">
              <i class="fa fa-filter"></i> {{ showFilters ? 'Hide Filters' : 'Show Filters' }}
            </button>
            <div class="filter-panel" [class.filter-panel-visible]="showFilters">
              <form [formGroup]="searchForm" (ngSubmit)="onSearch()" class="filter-form">
                <div class="row g-2 mb-2">
                  <div class="col-md-3 col-sm-6">
                    <div class="form-group compact">
                      <label for="dealerId" class="form-label compact-label">
                        <i class="fa fa-id-card"></i> Dealer ID
                      </label>
                      <input id="dealerId" type="text" class="form-control form-control-sm" formControlName="dealerId" placeholder="Dealer ID" />
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6">
                    <div class="form-group compact">
                      <label for="year" class="form-label compact-label">
                        <i class="fa fa-calendar"></i> Year
                      </label>
                      <input id="year" type="number" class="form-control form-control-sm" formControlName="year" min="2000" max="2099" />
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6">
                    <div class="form-group compact">
                      <label for="dealerCity" class="form-label compact-label">
                        <i class="fa fa-building"></i> City
                      </label>
                      <input id="dealerCity" type="text" class="form-control form-control-sm" formControlName="dealerCity" placeholder="City" />
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6">
                    <div class="form-group compact">
                      <label for="dealerState" class="form-label compact-label">
                        <i class="fa fa-globe"></i> State
                      </label>
                      <input id="dealerState" type="text" class="form-control form-control-sm" formControlName="dealerState" placeholder="State" />
                    </div>
                  </div>
                </div>
                <div class="row g-2 mb-2">
                  <div class="col-12">
                    <div class="action-buttons">
                      <button class="btn btn-sm btn-primary" type="submit" [disabled]="searchForm.invalid || loading">
                        <i class="fa fa-search" [class.fa-spin]="loading"></i> Search
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- Results Section -->
          <div class="results-container">
            <div class="results-header">
              <h5 class="mb-0"><i class="fa fa-table"></i> Results</h5>
              <span class="badge bg-info" *ngIf="rowData.length > 0">{{rowData.length}} records found</span>
            </div>
            <div class="grid-container">
              <div *ngIf="loading" class="text-center py-3">
                <i class="fa fa-spinner fa-spin fa-2x"></i>
                <p class="mt-2">Loading data...</p>
              </div>
              <div *ngIf="!loading" class="grid-wrapper">
                <ag-grid-angular
                  class="ag-theme-alpine dealer-grid"
                  [rowData]="rowData"
                  [columnDefs]="columnDefs"
                  [defaultColDef]="defaultColDef"
                  rowSelection="single"
                  [animateRows]="true"
                  [pagination]="true"
                  [paginationPageSize]="25"
                  [paginationPageSizeSelector]="[25, 50, 100]"
                  [suppressRowHoverHighlight]="false"
                  [rowHeight]="40"
                  [suppressNoRowsOverlay]="false"
                  [loadingOverlayComponent]="null"
                  [noRowsOverlayComponent]="null"
                  [suppressLoadingOverlay]="false"
                  (gridReady)="onGridReady($event)"
                  (cellClicked)="onGridCellClicked($event)"
                ></ag-grid-angular>
              </div>
              <div *ngIf="!loading && rowData.length === 0" class="alert alert-info mt-3">
                <i class="fa fa-info-circle"></i> No revenue records found for the selected criteria.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Upsert Modal -->
  <div class="modal" tabindex="-1" [class.show]="upsertMode" [style.display]="upsertMode ? 'block' : 'none'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add/Update Dealer Revenue</h5>
          <button type="button" class="btn-close" (click)="closeUpsertForm()"></button>
        </div>
        <form *ngIf="upsertForm" [formGroup]="upsertForm" (ngSubmit)="submitUpsert()">
          <div class="modal-body">
            <div class="row g-2">
              <div class="col-6">
                <label class="form-label">Month</label>
                <input type="text" class="form-control" formControlName="month" placeholder="MM" maxlength="2" />
              </div>
              <div class="col-6">
                <label class="form-label">Revenue Type</label>
                <select class="form-select" formControlName="revenueType">
                  <option value="IGST">IGST</option>
                  <option value="SGST">SGST</option>
                </select>
              </div>
              <div class="col-12">
                <label class="form-label">Revenue Amount</label>
                <input type="number" class="form-control" formControlName="revenue" min="0" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeUpsertForm()">Cancel</button>
            <button type="submit" class="btn btn-primary" [disabled]="upsertForm?.invalid || loading">
              <i class="fa fa-save" [class.fa-spin]="loading"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
